<div class="snooker-scoreboard-header">
    @if (points) {
        <div class="cell points">{{ scoreboardP }}</div>
    }
    @if (frames) {
        <div class="cell frames">{{ scoreboardF }}</div>
    }
</div>
